export default {"src":"/_next/static/media/feature-2.2ef33fd4.svg","height":175,"width":272,"blurWidth":0,"blurHeight":0};